module.exports = __webpack_public_path__ + "img/acme-square.4979af71.png";